const API_DRIVER = process.env.REACT_APP_API_DRIVER || 'local';
const API_HOST = process.env.REACT_APP_API_HOST || null;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || null;
const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT || 200;

export { API_DRIVER, API_HOST, API_BASE_URL, API_TIMEOUT };
